const handleImageClick = (item) => {
    const img = item.querySelector('img');
    const overlay = document.createElement('div');
    const container = document.createElement('div');
    const closeButton = document.createElement('button');
    const image = document.createElement('img');
    overlay.classList.add('image-gallery__overlay');
    overlay.classList.add('js-image-overlay');
    container.classList.add('image-gallery__overlay-container');
    closeButton.classList.add('image-gallery__close-button');
    closeButton.classList.add('js-image-overlay');
    image.classList.add('image-gallery__overlay-image');
    image.setAttribute('src', img.getAttribute('src'));
    closeButton.addEventListener('click', handleImageClose)
    container.appendChild(closeButton);
    container.appendChild(image);
    overlay.addEventListener('click', handleCloseOnOutsideClick);
    overlay.appendChild(container);
    document.body.appendChild(overlay);
    document.addEventListener('keyup', handleKeyUp);
}

const handleImageClose = () => {
    const overlay = document.querySelector('.js-image-overlay');
    if (!overlay) {
        return;
    }
    document.querySelector('.js-image-overlay').remove();
    document.removeEventListener('keyup', handleKeyUp);
}

const handleKeyUp = (e) => {
    if (e.key === 'Escape') {
        handleImageClose();
    }
}

const handleCloseOnOutsideClick = (e) => {
    if (e.target.classList.contains('image-gallery__overlay-image')) {
        return;
    }
    handleImageClose();
}

const handleExpandAll = (expander, items) => {
    expander.remove();
    [...items].map((item) => item.removeAttribute('hidden'));
}

const ImageGallery = (container) => {
    const items = container.querySelectorAll('.js-image-gallery-item');
    [...items].map((item) => item.addEventListener('click', () => handleImageClick(item)))
    const expander = container.querySelector('.js-image-gallery-expand');
    if (expander) {
        expander.addEventListener('click', () => handleExpandAll(expander, items));
    }
};

export default ImageGallery;
